var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreview = function SvgPreview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 12.9c-2-2.8-6.5-7.4-14.4-7.4S3.6 10.1 1.6 12.9c-1.7 2.4-1.7 5.7 0 8.1 2 2.8 6.5 7.4 14.4 7.4 7.8-.3 12.4-4.9 14.4-7.4 1.7-2.4 1.7-5.7 0-8.1m-3.3 5.5c-2 2.6-5.4 5.7-11.1 5.7s-9.4-2.9-11.1-5.5c-.7-1.1-.7-2.4 0-3.5 1.7-2.6 5.2-5.7 11.1-5.7s9.4 3 11.1 5.7c.9 1.1.9 2.4 0 3.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9 12.6c-.5-.3-1.1 0-1.1.6v7.5c0 .6.7.9 1.1.6l5.7-3.8c.4-.3.4-.9 0-1.2z"
  })));
};
export default SvgPreview;